import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { departmentActions } from '@app/store/department/actions/department.actions';
import { departmentsActions } from '../actions/departments.actions';
import { selectValue } from '../selectors/departments.selector';

@Injectable()
export class DepartmentsDepartmentBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(departmentActions.deleteDepartmentSuccess),
            concatLatestFrom(() => this.store.select(selectValue)),
            map(([, value]) => departmentsActions.getDepartments({ value })),
        );
    });
}
